/**
 * Single source of truth for the prices shown in the app. The
 * authoritative amounts charged live on the Stripe Prices (resolved by
 * lookup key in functions/billing.py); these are the display figures so
 * the UI copy can't drift between pages. The marketing site
 * (web/public/index.html) is a separate static surface — keep it in
 * sync by hand when these change.
 */

/** One-off hardware price, in whole pounds. Mirrors
 * billing.BUTTON_PRICE_GBP. */
export const BUTTON_PRICE_GBP = 79;

/** Monthly service price. Mirrors billing.MONTHLY_GBP. */
export const MONTHLY_GBP = 14.99;

/** Included runway (days) before the subscription's first charge.
 * Mirrors billing.INCLUDED_TRIAL_DAYS. */
export const INCLUDED_TRIAL_DAYS = 30;

/** Per-elder device cap. Mirrors MAX_BUTTONS_PER_ACCOUNT in
 * functions/main.py. */
export const MAX_BUTTONS_PER_ACCOUNT = 5;
